import React, { useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { IGreenSummary } from '../../greenTypes';
import { formatValueAsString } from '../../../../utils/helpers';
import { themeBalham } from 'ag-grid-enterprise';
import { ColDef } from 'ag-grid-community';

interface ISummaryProps {
	data: IGreenSummary[];
	loading?: boolean;
}

const GreenSummary: React.FC<ISummaryProps> = ({ ...props }) => {
	const gridRef = useRef<any>(null);

	const defaultColDef = useMemo<ColDef>(() => {
		return {
			flex: 1,
			// filter: 'agTextColumnFilter',
		};
	}, []);

	const onGridReady = (params: any) => {
		gridRef.current = params.api;
		gridRef.current!.sizeColumnsToFit();
	};

	const columnDefs = useMemo<ColDef[]>(() => {
		const options: Intl.NumberFormatOptions = { minimumFractionDigits: 0, maximumFractionDigits: 1 };
		return [
			{
				headerName: 'Sector',
				field: 'sectorName',
				cellStyle: (params) =>
					params.value === 'Total'
						? { backgroundColor: '#eeeeee', fontWeight: 'bold', color: 'black' }
						: { backgroundColor: '#eeeeee', fontWeight: 'normal', color: 'black' },
				aggFunc: () => 'Total',
			},
			{
				headerName: '# Ships',
				field: 'shipCount',
				valueFormatter: (params) => {
					return params.data && formatValueAsString(params.data.shipCount);
				},
			},
			{
				headerName: 'Average Size',
				field: 'avgSize',
				valueFormatter: (params: any) => {
					return params.data && formatValueAsString(params.data.avgSize, options, '', '', ' ' + params.data.sizeUnit);
				},
			},
			{
				headerName: 'Average Age',
				field: 'avgAge',
				valueFormatter: (params: any) => {
					return params.data && formatValueAsString(params.data.avgAge, options);
				},
			},
			{
				headerName: 'Alignment to CII Reference (%)',
				field: 'avgClimateAlignment',
				valueFormatter: (params: any) => {
					return params.data && formatValueAsString(params.data.avgClimateAlignment, options, '', '', ' %');
				},
				cellStyle: { backgroundColor: '#307731', color: 'white' },
				aggFunc: () => {
					const sum = props.data.reduce(
						(sum, vessel) => sum + (!Number.isNaN(vessel.avgClimateAlignment) ? vessel.avgClimateAlignment : 0),
						0,
					);
					const avg = sum / props.data.length;
					return formatValueAsString(avg, options, '', '', ' %');
				},
			},
		];
	}, []);

	return (
		<div className="w-full h-full">
			<AgGridReact
				ref={gridRef}
				columnDefs={columnDefs}
				rowData={props.data}
				onGridReady={onGridReady}
				loading={props.loading}
				theme={themeBalham}
				defaultColDef={defaultColDef}
				grandTotalRow="bottom"
			/>
		</div>
	);
};

export default GreenSummary;
